import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import { useLingui } from '@lingui/react';
import shuffleText from '../../../../utils/suffle-text';

var Copyright = function Copyright(_ref) {
  var place = _ref.place;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  useEffect(function () {
    var ids = ['copyright--side-drawer', 'copyright--footer'];
    ids.forEach(function (id) {
      shuffleText(id);
    });
  }, []);
  return /*#__PURE__*/React.createElement("small", {
    id: "copyright--" + place
  }, "\xA9 ", new Date().getFullYear(), " ", i18n._(
  /*i18n*/
  i18n._("kento takeuchi")));
};

export default Copyright;